import { OrderResponse } from "./order-response";

export class ProfileOrderResponse {
    orders: OrderResponse[];
    recordsCount: number;
}


// WEBPACK FOOTER //
// ./src/app/customerservice/interface/profile-order-response.ts